module.exports = __webpack_public_path__ + "img/trophy.60bb024d.svg";